import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import InputMask from 'react-input-mask'
import { Typography } from '@material-ui/core'
import { palette } from 'styles/colors'
import Input from 'components/Input'
import Button from 'components/Button'

const Course = ({ 
  classes, 
  formik, 
  handleSubmit,
  editedObj,
  editTableValue,
  deletedEducation,
  type,
  isEdit,
  close
}) => {
  let typeField = ''

  const onChange = (data, type) => {
    formik.setFieldValue(type, data.target.value)
  }

  useEffect(() => {
    if (editedObj) {
      formik.setFieldValue('courseName', editedObj.courseName)
      formik.setFieldValue('year', editedObj.year.toString())
    } else {
      formik.setFieldValue('courseName', '')
      formik.setFieldValue('year', '')
    }
  }, [])

  return (
    <div className={classes.wrapper}>
      <div className={classes.field}>
        <Typography 
          className={classes.title} 
          variant="subtitle1"
          style={{ width: '30%' }}
        >
          Название курса:
        </Typography>
        <Input
          formik={formik}
          fieldName={'courseName'}
          variant={'standard'}
          otherStyles={{ width: '100%' }}
          standard
        />
      </div>
      <div className={classes.field}>
        <Typography
          className={classes.title}
          variant="subtitle1"
        >
          Год:
        </Typography>
        <InputMask
          mask={'9999'}
          maskPlaceholder={''}
          value={formik.values.year}
          onChange={(data) => onChange(data, (typeField = 'year'))}
        >
          <Input
            formik={formik}
            fieldName={'year'}
            variant={'standard'}
            otherStyles={{ width: '100%' }}
            standard
          />
        </InputMask>
      </div>
      <div className={classes.buttons}>
        <Button
          text={'Сохранить'}
          otherStyles={{ 
            backgroundColor: palette.blueButton,
            color: palette.white,
            width: '250px',
            height: '40px',
            borderRadius: '10px',
            boxShadow: 'none',
          }}
          onClick={() => isEdit ? editTableValue(formik, deletedEducation, type, close) : handleSubmit(formik, close)}
        />
      </div>
    </div>
  )
}

const styles = () => ({
  wrapper: {
    width: '600px'
  },
  field: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  title: {
    fontWeight: 'bold',
    margin: '0 20px 10px 0'
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  '@global': {
    '.MuiDialog-paperWidthSm': {
      maxWidth: '600px'
    }
  }
})

export default withStyles(styles)(Course)